import type { BaseErrorResponse, GetFieldTypesRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useFieldType() {
  class FieldType<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Field type
     * @name FieldTypeControllerGetFieldTypes
     * @summary Getting a list of field types
     * @request GET:/api3/field-type
     * @secure
     * @response `200` `GetFieldTypesRes`
     * @response `400` `BaseErrorResponse`
     */
    fieldTypeControllerGetFieldTypes = (params: RequestParams = {}) =>
      this.request<GetFieldTypesRes, BaseErrorResponse>({
        path: '/api3/field-type',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new FieldType();
}
